import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeBanco } from "../../Models/Financeiro/Banco";
import { useQuery } from "@tanstack/react-query";
import RequestUtilitario, { QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";

export class BancoService {
    public listar(banco: TypeBanco): Promise<AxiosResponse<TypeBanco[]>> {
        return Axios.post<TypeBanco[]>(`Banco/listar`, banco);
    }

    public inserir(banco: TypeBanco) {
        return Axios.post('Banco/inserir', banco);
    }

    public atualizar(banco: TypeBanco){
        return Axios.put<TypeBanco>('Banco/atualizar', banco);
    }

    public ativar(codigoDoBanco: number){
        return Axios.patch(`Banco/ativar/${codigoDoBanco}`);
    }

    public desativar(codigoDoBanco: number){
        return Axios.patch(`Banco/desativar/${codigoDoBanco}`);
    }
}

export function useBancoListar({
    banco,
    ...rest
}:QueryBasicaParam<AxiosResponse<TypeBanco[]>, TypeBanco[], {
    banco?:TypeBanco,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(banco ?? {}),
    });

    return useQuery({
        ...rest,
        queryKey : ["Financeiro", "Conta", "Agencia", "Banco", "ListarTodos", queryString ],
        queryFn : () => Axios.post<TypeBanco[]>(`banco/listar?${queryString}`, banco ?? null),
        staleTime : 1000 * 60 * 2.5,
        select(data) {
            return data.data.map(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
                return m;
            });
        },
    });
}